export { default } from "./BottomNavigationAction.js";
export { default as bottomNavigationActionClasses } from "./bottomNavigationActionClasses.js";
export * from "./bottomNavigationActionClasses.js";